import React from 'react';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ActionBar, StyledEllipsis, StyledEllipsisTooltip, StyledButton } from './styled';
import {
  dimensionDrilldown,
  initFilter,
  toggleCompareRule,
  toggleRule,
} from '@store/trends/base/actions';
import { modeAtom, TABLE_MODES } from '../atoms';
import { useAtomValue } from 'jotai';
import { CopyOutlined } from '@ant-design/icons';
import copy from 'copy-to-clipboard';
import { ruleSetSelector } from '@store/trends/base/selectors';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import {
  DrillDownToEventScope,
  shouldDrillDownToEventPreset,
  useDrillDownToPreset,
} from '@components/common/DrillDownToEventScope';
import { isAppModule } from '@utils/constants';
// import { useContextMenu } from 'react-contexify';
// import ContextMenu, { MENU_ID } from './ContextMenu';

const actions = [{ label: <CopyOutlined />, value: 'copy' }];

const Cell = ({ cellData, column, rowData, disableDrilldown }) => {
  const dispatch = useDispatch();
  const mode = useAtomValue(modeAtom);
  const dimension = column.key;
  const { usecaseKey } = useSelector(activeDashboardSelector);

  // right click context menu
  // const { show } = useContextMenu({ id: `${MENU_ID}-${dimension}-${rowData.name[0]}` });
  // const displayMenu = (e) => {
  //   show(e);
  // };

  const activeRuleSet = useSelector(ruleSetSelector);
  const handleDrilldown = useDrillDownToPreset(dimension, rowData);
  const mergedDisableDrilldown = disableDrilldown || rowData.disableDrilldown;

  const handleClick = () => {
    if (!mergedDisableDrilldown) {
      switch (mode) {
        case TABLE_MODES.drilldown: {
          dispatch(dimensionDrilldown(dimension, rowData));
          break;
        }
        case TABLE_MODES.filter: {
          dispatch(toggleRule(dimension, rowData));
          break;
        }
        case TABLE_MODES.compare: {
          if (activeRuleSet.size === 0) {
            dispatch(initFilter({ dimension, row: rowData }));
          } else {
            dispatch(toggleCompareRule(dimension, rowData));
          }
          break;
        }
      }
    }
  };

  const handleActions = (value) => {
    if (value === 'copy') {
      return () => {
        if (copy(cellData, { format: 'text/plain' })) {
          message.info('Copied to clipboard');
        }
      };
    }
    if (value === 'drilldown_to_preset') {
      return () => {
        handleDrilldown();
      };
    }
    return () => null;
  };

  // DPI drilldown
  const resActions = [...actions];
  if (shouldDrillDownToEventPreset(dimension, usecaseKey)) {
    resActions.unshift({
      label: <div />,
      value: 'drilldown_to_preset',
    });
  }

  // context menu to open in a new tab, disabled
  // onContextMenu={displayMenu}
  return (
    <>
      <StyledEllipsis onClick={handleClick} disableDrilldown={mergedDisableDrilldown}>
        <StyledEllipsisTooltip text={cellData} />
      </StyledEllipsis>
      {rowData.totalRow ? null : (
        <>
          <Actions
            actions={resActions}
            handleActions={handleActions}
            dimension={dimension}
            rowData={rowData}
          />
          {/* <ContextMenu dimension={dimension} rowData={rowData}  /> */}
        </>
      )}
    </>
  );
};

const Actions = ({ actions, handleActions, dimension, rowData }) => {
  return (
    <ActionBar className="action-bar">
      {actions.map((action) => {
        if (action.value === 'drilldown_to_preset') {
          return (
            <DrillDownToEventScope
              dimension={dimension}
              handleAction={handleActions(action.value)}
              key={action.value}
            />
          );
        }
        return (
          <StyledButton
            key={action.value}
            type="text"
            icon={action.label}
            $isAppModule={isAppModule}
            onClick={handleActions(action.value)}
          />
        );
      })}
    </ActionBar>
  );
};

export default Cell;
